export const NEW_PLANS_DATA: {
  [key: string]: {
    title: string
    subtitle: string
    intro: string
    features: string[]
    price: number
  }
} = {
  basic_cora: {
    title: 'CORA',
    subtitle: 'Plano básico com integração Cora para gestão de recebimentos.',
    intro: 'O plano <b>Cora</b> inclui:',
    features: [
      'Link de Cadastro de Cliente, upload de planilha, cadastro inteligente',
      'Envio inteligente de notificações (Email, WhatsApp e SMS)',
      'Templates de Contratos',
      'Criação de até 10 links e 10 planos',
      'Régua inteligente, notificações extras, régua personalizada',
      '3 usuários',
      'Módulo de Contas a Pagar',
      'Envio de 300 mensagens e 100 documentos por mês',
      'Integração com conta Cora'
    ],
    price: 99
  },
  start: {
    title: 'START',
    subtitle:
      'Para empresas que querem uma gestão avançada e inteligente dos seus recebimentos recorrentes.',
    intro: 'O plano <b>Start</b> inclui:',
    features: [
      '100 cobranças grátis todos os meses (PIX e boleto)',
      'Lembretes por e-mail e WhatsApp em toda a régua de cobrança',
      'Emissão nota fiscal de serviço',
      'Planos e Links de Contratação Ilimitados',
      'Página de Vendas',
      'Assinatura eletrônica de contratos',
      '3 usuários',
      'Módulo de Contas a Pagar',
      '300 comunicados por mês no Portal de Clientes (mensagens e arquivos)',
      'Assistente de AI',
      'API e webhooks para integração'
    ],
    price: 99
  },
  grow: {
    title: 'GROW',
    subtitle:
      'Para empresas que querem uma gestão avançada e inteligente da sua operação recorrente.',
    intro: 'Tudo do <b>Start</b>, mais:',
    features: [
      'Régua de cobrança personalizada',
      'Contrato gerado e enviado automaticamente no cadastro do cliente',
      'Aceite de Termos de Uso e Upload de Documentos no onboarding de clientes',
      'Até 10 usuários',
      'Módulo de Contas a Pagar e Receber Avançados',
      'Configurações Avançadas do Portal de Clientes e da Fatura',
      '1.000 comunicados por mês no Portal de Clientes (mensagens e arquivos)',
      'Métricas e dashboards avançados'
    ],
    price: 299
  },
  scale: {
    title: 'SCALE',
    subtitle:
      'Para empresas que querem personalização avançada na gestão da sua operação recorrente.',
    intro: 'Tudo do <b>Grow</b>, mais:',
    features: [
      'Remove 100% a marca Base de Clientes',
      'Usuários ilimitados',
      'Assistente de AI avançado',
      '3.000 comunicados por mês no Portal de Clientes (mensagens e arquivos)',
      'API e webhooks para integração + integrações nativas',
      'Métricas e dashboards personalizados',
      'URL e domínio personalizados',
      'Suporte com Account Manager e Slack',
      'Comitê de Produto'
    ],
    price: 799
  }
}
